export const DISABLE_SORTING = 'DISABLE_SORTING' as const;
export const ENABLE_SORTING = 'ENABLE_SORTING' as const;
export const LOAD_DATA = 'LOAD_DATA' as const;

export const START_DRAG = 'START_DRAG' as const;
export const END_DRAG = 'END_DRAG' as const;
export const CANCEL_DRAG = 'CANCEL_DRAG' as const;
